import { useTranslation } from 'react-i18next'

// local imports
import locationMyOffice from 'assets/icons/location.svg'
import locationCommon from 'assets/icons/location-shared.svg'
import { IAllLocationList } from 'types/LocationType'
import { ListItem, ListViewContainer, StyledLink } from './styled'

interface ListContainerProps {
  locationList: IAllLocationList[] | undefined
  openSidebar: (e: any, location: IAllLocationList) => void
}

function ListContainer({ locationList, openSidebar }: ListContainerProps) {
  const { t } = useTranslation()

  const setItemIcon = (isMyFirm: boolean) => {
    if (!isMyFirm) return locationCommon
    else return locationMyOffice
  }

  return (
    <ListViewContainer>
      {locationList?.map((dt) => (
        <ListItem key={dt.id}>
          <div className="mr-4">
            <img src={setItemIcon(!!dt.isMyFirmLocation)} className="location-img " alt="map-location" />
          </div>
          <div className="list-content">
            <div className="title">{dt.name}</div>
            <div className="subtitle">{dt.firmName}</div>
            <div className="desc">{dt.address}</div>
          </div>

          <div className=" px-3">
            <StyledLink to="/" onClick={(e) => openSidebar(e, dt)}>
              {t('buttons.go-to-floor')}
            </StyledLink>
          </div>
        </ListItem>
      ))}
    </ListViewContainer>
  )
}

export default ListContainer
